import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Crown: BleskIcon = forwardRef(function Crown(props, ref) {
  return (
    <BaseIcon {...props} ref={ref} viewBox="0 0 12 12">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00096 4.99958L10.2245 3.51719C10.378 3.41487 10.5754 3.40533 10.738 3.49237C10.9007 3.57942 11.0022 3.74892 11.0022 3.9334V9.00125C11.0022 9.55376 10.5543 10.0017 10.0018 10.0017H1.99846C1.44595 10.0017 0.998047 9.55376 0.998047 9.00125V3.9334C0.998047 3.74893 1.09959 3.57944 1.26224 3.4924C1.42488 3.40536 1.62223 3.4149 1.77572 3.51722L3.9993 4.99958L5.58396 2.62259C5.67673 2.48343 5.83291 2.39984 6.00016 2.39984C6.16741 2.39984 6.32359 2.48343 6.41636 2.62259L8.00096 4.99958Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
